import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const DeliveryAddressSection = ({ address }) => {
  const [isEditing, setIsEditing] = useState(false);
  const [editedAddress, setEditedAddress] = useState(address);

  const handleSave = () => {
    // In production, this would update the address via API
    setIsEditing(false);
  };

  const handleCancel = () => {
    setEditedAddress(address);
    setIsEditing(false);
  };

  return (
    <div className="bg-card rounded-xl shadow-lg p-4 md:p-6 lg:p-8">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 md:w-12 md:h-12 bg-accent/10 rounded-lg flex items-center justify-center">
            <Icon name="MapPin" size={20} color="var(--color-accent)" />
          </div>
          <h2 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground">Delivery Address</h2>
        </div>
        {!isEditing && (
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit2"
            iconPosition="left"
            onClick={() => setIsEditing(true)}
          >
            Edit
          </Button>
        )}
      </div>

      {!isEditing ? (
        <div className="space-y-3 md:space-y-4">
          <div className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
            <Icon name="MapPin" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
            <div className="flex-1">
              <p className="font-semibold text-foreground text-sm md:text-base mb-1">{address?.zone}</p>
              <p className="text-xs md:text-sm text-muted-foreground">{address?.street}</p>
            </div>
          </div>

          {address?.landmark && (
            <div className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
              <Icon name="Navigation" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
              <div className="flex-1">
                <p className="font-semibold text-foreground text-xs md:text-sm mb-1">Landmark</p>
                <p className="text-xs md:text-sm text-muted-foreground">{address?.landmark}</p>
              </div>
            </div>
          )}

          <div className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
            <Icon name="Phone" size={18} color="var(--color-primary)" className="flex-shrink-0 mt-1" />
            <div className="flex-1">
              <p className="font-semibold text-foreground text-xs md:text-sm mb-1">Contact Number</p>
              <p className="text-xs md:text-sm text-muted-foreground">{address?.phone}</p>
            </div>
          </div>

          <div className="bg-accent/10 rounded-lg p-3 md:p-4 border border-accent/30">
            <div className="flex gap-2">
              <Icon name="Info" size={16} color="var(--color-accent)" className="flex-shrink-0 mt-0.5" />
              <p className="text-xs md:text-sm text-foreground">
                Our delivery driver will contact you before arrival. Please keep your phone accessible.
              </p>
            </div>
          </div>
        </div>
      ) : (
        <div className="space-y-4">
          <Input
            type="text"
            label="Delivery Zone"
            value={editedAddress?.zone}
            onChange={(e) => setEditedAddress({ ...editedAddress, zone: e?.target?.value })}
          />
          <Input
            type="text"
            label="Street Address"
            value={editedAddress?.street}
            onChange={(e) => setEditedAddress({ ...editedAddress, street: e?.target?.value })}
          />
          <Input
            type="text"
            label="Landmark (Optional)"
            value={editedAddress?.landmark}
            onChange={(e) => setEditedAddress({ ...editedAddress, landmark: e?.target?.value })}
          />
          <Input
            type="tel"
            label="Contact Number"
            value={editedAddress?.phone}
            onChange={(e) => setEditedAddress({ ...editedAddress, phone: e?.target?.value })}
          />
          <div className="flex gap-2">
            <Button
              variant="default"
              size="default"
              iconName="Check"
              iconPosition="left"
              onClick={handleSave}
              className="flex-1"
            >
              Save Changes
            </Button>
            <Button
              variant="outline"
              size="default"
              onClick={handleCancel}
              className="flex-1"
            >
              Cancel
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeliveryAddressSection;